import React, { Component } from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import Gallery from "./gallery-v1";

class ApartmentV1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: 0,
    };
  }

  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    let CustomClass = this.props.CustomClass ? this.props.CustomClass : "";

    return (
      <div
        className={"ltn__apartments-plan-area pt-115--- pb-70 " + CustomClass}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center">
                <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">
                  Service Details
                </h6>
                <h1 className="section-title">{this.props.value.name}</h1>
              </div>
              <div className="ltn__tab-menu ltn__tab-menu-3 ltn__tab-menu-top-right-- text-uppercase--- text-center">
                <div className="nav">
                  {this.props.value.subCategory &&
                    this.props.value?.subCategory.map((data, key) => {
                      return (
                        <React.Fragment key={key}>
                          <a
                            className={
                              this.state.selectedValue === key
                                ? "active show"
                                : ""
                            }
                            onClick={() => {
                              this.setState({
                                selectedValue: key,
                              });
                            }}
                            data-bs-toggle="tab"
                            href={`#`}
                          >
                            {data.title}
                          </a>
                        </React.Fragment>
                      );
                    })}
                </div>
              </div>
              <div className="tab-content">
                {this.props.value.subCategory &&
                  this.props.value?.subCategory.map((data, key) => {
                    // console.log("sdsdssdssasaasasasa", data, key);
                    return (
                      <React.Fragment key={key}>
                        <div
                          className={`tab-pane fade ${
                            this.state.selectedValue === key
                              ? "active show"
                              : ""
                          }`}
                          id={key}
                        >
                          <div className="ltn__apartments-tab-content-inner">
                            <div className="row">
                              <div className="col-lg-6">
                                <div
                                  className="apartments-plan-info ltn__secondary-bg text-color-white"
                                  style={{ minHeight: "568px" }}
                                >
                                  <h2>{data.SubTitle}</h2>
                                  <p class="custom-txt-desc">{data.Description}</p>
                                </div>
                              </div>
                              {data.video ? (
                                <div className="col-lg-6">
                                  <div
                                    className="apartments-plan-img"
                                    style={{ borderRadius: "50px" }}
                                  >
                                    <video
                                      autoPlay
                                      muted
                                      loop
                                      width="570"
                                      height="570"
                                      className="apartments-plan-img"
                                      style={{maxWidth: "100%"}}
                                    >
                                      <source
                                        src={data?.videoUrl}
                                        type="video/mp4"
                                      />
                                    </video>
                                  </div>
                                </div>
                              ) : (
                                <div className="col-lg-6">
                                  <div
                                    className="apartments-plan-img"
                                    style={{ borderRadius: "50px" }}
                                  >
                                    <img
                                      src={data.images}
                                      alt="#"
                                      style={{ borderRadius: "20px" }}
                                    />
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                          <div>
                            {data.galleryImages.length === 0 ? null : (
                              <Gallery value={data.galleryImages} />
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>

        {/* <Gallery value={value}/> */}
      </div>
    );
  }
}

export default ApartmentV1;
